import { createIcon } from "@chakra-ui/react";

const AddIcon = createIcon({
  displayName: "AddIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 12.75H6V11.25H18V12.75Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.25 18L11.25 6L12.75 6L12.75 18H11.25Z"
        fill="currentColor"
      />
    </>
  ),
});

export default AddIcon;
